import React from 'react'
import { Input, Button, Table, Modal } from "antd";
import StyledPeoplePage from "../../../Pages/Settings/People/style";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useNavigate } from 'react-router-dom'; 

const Customstyle = styled.div`
 text-align:left;
  .acourse-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 20.83px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #1F243B;
  }
  
  .search-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-top: 20px;
    width: 100%;
  }

  .total-course {
    font-size: 16px;
    font-weight: normal;
  }

  .searchbar-style {
    height: 34px;
    width: 210px;
    border-radius: 24px;
    padding: 8px;
  }

  .table-container {
    margin-top: 30px;
  }

  .custom-table {
    width: 100%;
    border-radius: 8px;
  }
  
  .table-row-white {
    background-color: #fff;
  }

  .table-row-gray {
    background-color: #f9f9f9;
  }

    .ant-table-cell {
    gap: 10px; 
    opacity: 1;
  }

  .ant-table-thead > tr > th {
    width: 536px; 
    height: 51px; 
  }

  .ant-table-tbody > tr > td {
    height: 48px; 
  }
  `;
  
function ReportGroup() {

    const navigate = useNavigate();

    const columns = [

        {
          title: "Name",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "No. of People in",
          dataIndex: "noofpeoplein",
          key: "noofpeoplein",
        },

      ];
      const data = [
        {
            name: "Design",
            noofpeoplein: "200",
        },
        {         
            name: "Design",
            noofpeoplein: "200",
        },
        {          
            name: "Design",
            noofpeoplein: "200",
        },
        {          
            name: "Design",
            noofpeoplein: "200",
        },
      ];

      const handleRowClick = (record) => {
        navigate("/groupdesign");
      };

  return (
    <div>
        <StyledPeoplePage>
            <Customstyle>
        <p className='acourse-text'>Group Report</p>
        <br/>
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <div>
          Total Course : {data.length}
        </div>
        <div>
              <Input
                placeholder="Search"
                // onChange={handleSearch}
                prefix={<SearchOutlined style={{ color: "#636980",}} />}
                className="searchbar-style"
              />
          </div>
      </div>
          <br/>
          <Table
                      columns={columns}
                      dataSource={data}
                      rowClassName={(record, index) =>
                        index % 2 === 0 ? "table-row-white" : "table-row-gray"
                      }
                      className="custom-table"
                      pagination={false}
                      onRow={(record) => ({
                        onClick: () => handleRowClick(record), // Trigger row click event
                      })}
                      // onRow={(record, index) => handleRowClick(record)}
                    />
          </Customstyle>
          </StyledPeoplePage>
    </div>
  )
}
export default ReportGroup